/**
 * @generated SignedSource<<1dc9178ccaa0255f51d9937c60d2f14a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternBrandJobsHealthQuery$variables = {
  brandId: string;
};
export type InternBrandJobsHealthQuery$data = {
  readonly internJobHealthMetrics: {
    readonly avgDurationMs: number | null;
    readonly failureCount: number;
    readonly failuresLastHour: number;
    readonly jobsLastHour: number;
    readonly retryCount: number;
    readonly runningCount: number;
    readonly successCount: number;
    readonly successRate: number;
    readonly totalJobs: number;
  };
  readonly internJobTaskNames: ReadonlyArray<{
    readonly count: number;
    readonly failureCount: number;
    readonly successCount: number;
    readonly taskName: string;
  }>;
};
export type InternBrandJobsHealthQuery = {
  response: InternBrandJobsHealthQuery$data;
  variables: InternBrandJobsHealthQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "brandId",
  "variableName": "brandId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "successCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failureCount",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "hours",
        "value": 24
      }
    ],
    "concreteType": "JobHealthMetrics",
    "kind": "LinkedField",
    "name": "internJobHealthMetrics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalJobs",
        "storageKey": null
      },
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "runningCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "retryCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avgDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobsLastHour",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failuresLastHour",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "TaskNameCount",
    "kind": "LinkedField",
    "name": "internJobTaskNames",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandJobsHealthQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandJobsHealthQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "d5234f1c29e7c747ff6c420eba56c97e",
    "id": null,
    "metadata": {},
    "name": "InternBrandJobsHealthQuery",
    "operationKind": "query",
    "text": "query InternBrandJobsHealthQuery(\n  $brandId: String!\n) {\n  internJobHealthMetrics(brandId: $brandId, hours: 24) {\n    totalJobs\n    successCount\n    failureCount\n    runningCount\n    retryCount\n    successRate\n    avgDurationMs\n    jobsLastHour\n    failuresLastHour\n  }\n  internJobTaskNames(brandId: $brandId) {\n    taskName\n    count\n    successCount\n    failureCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1863736092233a76c54ce6eeb0a4711";

export default node;
